<section [ngClass]="dynamicClass">
  <div class="pb-container pb-mb-6 lg:pb-mb-7">
    <h2 *ngIf="rendering?.fields?.result?.Title" data-title="true" class="pb-text-d-xl-m lg:pb-text-d-xl pb-font-serif pb-mb-2 lg:pb-mb-4 pb-text-color-brand">{{ rendering?.fields?.result?.Title }}</h2>
    <div *ngIf="productCategoryList?.length > 0" class="pb-mt-4 lg:pb-mt-6">
        <div #FilterSlider class="pb-m-filter swiper pb-swiper-filter">
          <div class="swiper-wrapper !pb-w-fit lg:pb-flex-wrap lg:!pb-translate-x-0">
              
              <ng-container *ngFor="let item of productCategoryList; let first = first">
                  <div class="swiper-slide !pb-w-fit pb-py-3 pb-cursor-pointer pb-whitespace-nowrap">
                      <a hybridHref hreflang="{{language}}" href="{{item?.link}}" class="pb-c-filter-item"
                          [ngClass]="item.active ? 'pb-filter--active':'' ">
                          {{item.name}}
                      </a>
                  </div>
                </ng-container>
          </div>
      </div>
    </div>
  </div>
  <div #CardSlider *ngIf="rendering?.fields?.result?.Services.length > 0" class="swiper pb-swiper-slider-mobile pb-mobile-swiper-fm">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper lg:pb-grid lg:pb-grid-cols-3 lg:pb-gap-x-6 lg:pb-gap-y-13 lg:!pb-translate-x-0">
        <!-- Slides -->
        <ng-container *ngFor="let card of rendering?.fields?.result?.Services">
            <div class="swiper-slide !pb-w-[310px] lg:!pb-w-full !pb-h-auto">
                <a hybridHref hreflang="{{language}}" href="{{card?.Link?.Href}}" >
                    <div class="pb-h-full !pb-justify-normal pb-card pb-card-product pb-card-product-with-img pb-theme--{{ theme }}">
                        <div *ngIf="card?.ProductType" class="pb-p-4 pb-card-top pb-relative pb-flex pb-justify-between pb-items-center">
                            <h4 class="pb-text-xs-m lg:pb-text-xs pb-font-bold">
                            {{ card?.ProductType | translate }}
                            </h4>
                        </div>
                        <div *ngIf="card?.ImageMobile?.Href" class="pb-card-product-img-placeholder">
                            <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="card?.ImageMobile.Href" alt="{{card?.ImageMobile.Alt}}" >
                        </div>

                        <div class="pb-p-5 pb-card-bottom pb-h-full pb-flex pb-flex-col ">
                            <div>
                                <h3 *ngIf="card?.Title" class="pb-text-h-xs-m lg:pb-text-h-sm pb-font-bold pb-mb-2 pb-line-clamp-3 pb-h-[3lh]">
                                    {{card?.Title | translate}}
                                </h3>
                                <div *ngIf="card?.Subtitle" class="pb-line-clamp-3 pb-h-[3lh]">
                                    {{card?.Subtitle | translate}}
                                </div>
                            </div>
                            <hr *ngIf="card?.KeyFeaturesProductGallery" class="pb-mt-4 pb-mb-2" />
                            <div *ngIf="card?.KeyFeaturesProductGallery" class="pb-article pb-article-piraeus " [innerHTML]="card?.KeyFeaturesProductGallery"></div>
                        </div>

                    </div>
                </a>
            </div>
        </ng-container>
    </div>
  </div>
  <div *ngIf="visibleShowmore" class="pb-hidden pb-justify-center pb-mt-8 lg:pb-flex">
    <div class="pb-btn pb-btn-secondary pb-w-full md:pb-w-fit" (click)="showMore()">
      {{ 'show-more' | translate }}
    </div>
  </div>
</section>
